import React from 'react';
import { Status } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

export const ActiveStatus = ({ isActive }) => {
    const colorsMap = {
        true: 'green',
        false: 'red'
    };

    const translationsMap = {
        true: 'common.active',
        false: 'common.inactive'
    };

    const { t } = useTranslation();

    return (
        <Status name="active" color={colorsMap[isActive]} responsive>
            {t(translationsMap[isActive])}
        </Status>
    );
};

ActiveStatus.propTypes = {
    isActive: PropTypes.bool.isRequired
};
